import Home from '../pages/site/home';
import SystemCheck from '../pages/system/check';
import NotFoundPage from '../pages/outros/not_found_page';
// Painel
import HomePainel from '../pages/outros/home_painel';
import SemPermissao from '../pages/outros/sem_permissao';
import Usuarios from '../pages/seguranca/usuarios';
import UsuariosAlterar from '../pages/seguranca/usuarios_alterar';
import Perfis from '../pages/seguranca/perfis';
import PerfisAlterar from '../pages/seguranca/perfis_alterar';
import Departamentos from '../pages/seguranca/departamentos';
import DepartamentosAlterar from '../pages/seguranca/departamentos_alterar';
import OrgaosEmpresas from '../pages/seguranca/orgaos_empresas';
import OrgaosEmpresasAlterar from '../pages/seguranca/orgaos_empresas_alterar';
import PerfilAcoes from '../pages/tabelas_basicas/acoes';
import PerfilAcoesAlterar from '../pages/tabelas_basicas/acoes_alterar';
import Funcionalidades from '../pages/outros/funcionalidades';
import FuncionalidadesAlterar from '../pages/outros/funcionalidades_alterar';
import TiposServidor from '../pages/seguranca/tipos_servidores';
import TiposServidorAlterar from '../pages/seguranca/tipos_servidores_alterar';
import CategoriasCNH from '../pages/tabelas_basicas/categorias_cnh';
import CategoriasCNHAlterar from '../pages/tabelas_basicas/categorias_cnh_alterar';
import { CidadesListar, CidadesAlterar } from '../pages/tabelas_basicas/cidades';
import Estados from '../pages/tabelas_basicas/estados';
import EstadosAlterar from '../pages/tabelas_basicas/estados_alterar';
import GrausEscolaridade from '../pages/tabelas_basicas/graus_escolaridade';
import GrausEscolaridadeAlterar from '../pages/tabelas_basicas/graus_escolaridade_alterar';
import NiveisEscolaridade from '../pages/tabelas_basicas/niveis_escolaridade';
import NiveisEscolaridadeAlterar from '../pages/tabelas_basicas/niveis_escolaridade_alterar';
import OrgaosEmissoresRG from '../pages/tabelas_basicas/orgaos_emissores_rg';
import OrgaosEmissoresRGAlterar from '../pages/tabelas_basicas/orgaos_emissores_rg_alterar';
import EstadosCivis from '../pages/tabelas_basicas/estados_civis';
import EstadosCivisAlterar from '../pages/tabelas_basicas/estados_civis_alterar';
import TiposLogradouros from '../pages/tabelas_basicas/tipos_logradouros';
import TiposLogradourosAlterar from '../pages/tabelas_basicas/tipos_logradouros_alterar';
import OrientacoesSexuais from '../pages/tabelas_basicas/orientacoes_sexuais';
import OrientacoesSexuaisAlterar from '../pages/tabelas_basicas/orientacoes_sexuais_alterar';
import IdenditadesGenero from '../pages/tabelas_basicas/identidade_genero';
import IdenditadesGeneroAlterar from '../pages/tabelas_basicas/identidade_genero_alterar';
import TiposRacasCores from '../pages/tabelas_basicas/tipos_racas_cores';
import TiposRacasCoresAlterar from '../pages/tabelas_basicas/tipos_racas_cores_alterar';
import Instituicoes from '../pages/contratos_convenios/instituicoes';
import InstituicoesAlterar from '../pages/contratos_convenios/instituicoes_alterar';
import TiposTermosDocumentos from '../pages/contratos_convenios/tipos_termo_documentos';
import TiposTermosDocumentosAlterar from '../pages/contratos_convenios/tipos_termo_documentos_alterar';
import TiposContratos from '../pages/contratos_convenios/tipos_contratos';
import TiposContratosAlterar from '../pages/contratos_convenios/tipos_contratos_alterar';
import TiposEmpresas from '../pages/contratos_convenios/tipos_empresas';
import TiposEmpresasAlterar from '../pages/contratos_convenios/tipos_empresas_alterar';
import AgenciasBancarias from '../pages/contratos_convenios/agencias_bancarias';
import AgenciasBancariasAlterar from '../pages/contratos_convenios/agencias_bancarias_alterar';
import TiposContasBancarias from '../pages/contratos_convenios/tipos_contas_bancarias';
import TiposContasBancariasAlterar from '../pages/contratos_convenios/tipos_contas_bancarias_alterar';
import { TiposTransferenciasListar, TiposTransferenciasAlterar } from '../pages/vagas/tipos_transferencias';
import { TiposContatosAlterar, TiposContatosListar } from '../pages/reecrutamentos/tipos_contatos';
import { TiposNaturezasCrimesAlterar, TiposNaturezasCrimesListar } from '../pages/reecrutamentos/tipos_naturezas_crimes';
import { TiposSaidasAlterar, TiposSaidasListar } from '../pages/reecrutamentos/tipos_saidas';
import { CategoriasContasBancariasAlterar, CategoriasContasBancariasListar } from '../pages/tabelas_basicas/categorias_contas_bancarias';
import { TiposImoveisAlterar, TiposImoveisListar } from '../pages/reecrutamentos/tipos_imoveis';
import { TiposFormacoesAlterar, TiposFormacoesListar } from '../pages/reecrutamentos/tipos_formacoes';
import { TiposDependenciasAlterar, TiposDependenciasListar } from '../pages/reecrutamentos/tipos_dependencias';
import { TiposSexosAlterar, TiposSexosListar } from '../pages/tabelas_basicas/tipos_sexos';
import { TiposComorbidadesAlterar, TiposComorbidadesListar } from '../pages/reecrutamentos/tipos_comorbidades';
import { TiposRegimesAlterar, TiposRegimesListar } from '../pages/reecrutamentos/tipos_regimes';
import { TiposDocumentosListar, TiposDocumentosEditar } from '../pages/reecrutamentos/tipos_documentos';
import { ReeducandosListar, ReeducandosAlterar } from '../pages/reecrutamentos/reeducandos';
import { PerfisLaboraisListar, PerfisLaboraisAlterar } from '../pages/vagas/perfis_laboraris';
import { JornadasTrabalhoListar, JornadasTrabalhoAlterar } from '../pages/vagas/jornadas_trabalho';
import { TiposStatusVagasListar, TiposStatusVagasAlterar } from '../pages/vagas/tipos_status_vagas';
import { TiposVinculosTrabalhosAlterar, TiposVinculosTrabalhosListar } from '../pages/vagas/tipos_vinculos_trabalho';
import { OfertasVagasTrabalhosAlterar, OfertasVagasTrabalhosListar, OfertasVagasAlterarVagas } from '../pages/vagas/ofertas_vagas_trabalho';
import { SelecaoProfissionaisListar, SelecaoVagas } from '../pages/vagas/selecao_profissionais';
import { AtendimentosListar, AtendimentosEditar, AtendimentosDetalheVaga } from '../pages/vagas/atendimentos';
import { ContratosTrabalhoEditar, ContratosTrabalhoListar } from '../pages/vagas/contratos_trabalho';
import { TiposAtendimentosListar, TiposAtendimentosAlterar } from '../pages/acolhimento/tipos_atendimentos';
import { ModalidadesAtendimentosListar, ModalidadesAtendimentosAlterar } from '../pages/acolhimento/modalidades_atendimentos';
import { UnidadesPenitenciariasListar, UnidadesPenitenciariasAlterar } from '../pages/acolhimento/unidades_penitenciarias';
import { AtendimentosInsercaoLaboralListar, AtendimentosInsercaoLaboralEditar } from '../pages/acolhimento/atendimentos_insercao_laboral';
import { AtendimentosControleSocialListar, AtendimentosControleSocialEditar, AtendimentosControleSocialReeducando, } from '../pages/acolhimento/encaminhamentos_controle_social';
import { AtendimentosIdentificacaoCivilListar, AtendimentosIdentificacaoCivilEditar } from '../pages/acolhimento/atendimentos_identificacao_civil';
import { AtendimentosSeeuListar, AtendimentosSeeuEditar } from '../pages/acolhimento/atendimentos_seeu';
import { AtendimentosReintegracaoListar, AtendimentosReintegracaoEditar } from '../pages/acolhimento/atendimentos_reintegracao';
import { AtendimentosAcolhimnetoListar, AtendimentosAcolhimnetoEditar } from '../pages/acolhimento/atendimentos_acolhimento';
import Logout from '../pages/outros/logout';
import { ParametrosInstituicoesEditar, ParametrosInstituicoesListar, ParametrosInstituicoesConfigurar } from '../pages/financeiro/parametros_instituicoes';
import { ParametrosParametrosFolhasListar, ParametrosParametrosFolhasEditar } from '../pages/financeiro/parametros_folhas';
import { VinculosGestao } from '../pages/financeiro/vinculos';
import { RubricasFolhasEditar } from '../pages/financeiro/rubricas_folha';
import { LancamentosFolhasEditar, LancamentosFolhasListar } from '../pages/financeiro/lancamentos_folhas';
import { FolhasMensaisListar } from '../pages/financeiro/folhas_mensais';
import { FolhasComplementaresListar } from '../pages/financeiro/folhas_complementares';
import { ValidacaoDiariaListar, ValidacaoDiariaDetalhes } from '../pages/gestao_frequencia/validacao_diaria';
import { TratamentoJustificativasListar } from '../pages/gestao_frequencia/tratamento_justificativas';
import { ControleJustificativasListar, ControleJustificativasEditar } from '../pages/gestao_frequencia/controle_justificativas';
import { FechamentoMensalListar } from '../pages/gestao_frequencia/fechamento_mensal';
import { PainelAnaliseFunacListar } from '../pages/gestao_frequencia/painel_analise_funac';
import { FilaAnaliseFunacListar } from '../pages/gestao_frequencia/fila_analise_funac';
import { RelatorioFrequencia } from '../pages/gestao_frequencia/relatorio_frequencia';
var PrefixoAdmin = '/painel';
export var ROUTES = {
    // site
    HOME_SITE: "/",
    LOGOUT: "".concat(PrefixoAdmin, "/logout"),
    SEM_PERMISSAO: "/sem-permissao",
    SYSTEM_CHECK: "/system/check",
    USUARIOS: "".concat(PrefixoAdmin, "/usuarios"),
    PERFIS: "".concat(PrefixoAdmin, "/perfis"),
    DEPARTAMENTOS: "".concat(PrefixoAdmin, "/departamentos"),
    ORGAOS_EMPRESAS: "".concat(PrefixoAdmin, "/orgaos-empresas"),
    ACOES: "".concat(PrefixoAdmin, "/acoes"),
    FUNCIONALIDADES: "".concat(PrefixoAdmin, "/funcionalidades"),
    TIPOS_SERVIDORES: "".concat(PrefixoAdmin, "/tipos-servidores"),
    CATEGORIAS_CNH: "".concat(PrefixoAdmin, "/categorias-cnh"),
    CIDADES: "".concat(PrefixoAdmin, "/cidades"),
    ESTADOS: "".concat(PrefixoAdmin, "/estados"),
    ESTADOS_CIVIS: "".concat(PrefixoAdmin, "/estados-civis"),
    GRAUS_ESCOLARIDADE: "".concat(PrefixoAdmin, "/graus-escolaridade"),
    IDENTIDADES_GENERO: "".concat(PrefixoAdmin, "/identidades-genero"),
    NIVEIS_ESCOLARIDADE: "".concat(PrefixoAdmin, "/niveis-escolaridade"),
    ORGAOS_EMISSORES_RG: "".concat(PrefixoAdmin, "/orgaos-emissores-rg"),
    ORIENTACOES_SEXUAIS: "".concat(PrefixoAdmin, "/orientacoes-sexuais"),
    TIPOS_LOGRADOUROS: "".concat(PrefixoAdmin, "/tipos-logradouros"),
    TIPOS_RACAS_CORES: "".concat(PrefixoAdmin, "/tipos-racas-cores"),
    //CONTRATOS_CONVENIOS
    CC_INSTITUICOES: "".concat(PrefixoAdmin, "/instituicoes"),
    CC_TIPOS_TERMOS_DOCUMENTOS: "".concat(PrefixoAdmin, "/tipos-termos-documentos"),
    CC_TIPOS_EMPRESAS: "".concat(PrefixoAdmin, "/tipos-empresas"),
    CC_TIPOS_CONTRATOS: "".concat(PrefixoAdmin, "/tipos-contratos"),
    AGENCIAS_BANCARIAS: "".concat(PrefixoAdmin, "/agencias-bancarias"),
    TIPOS_CONTAS_BANCARIAS: "".concat(PrefixoAdmin, "/tipos-contas-bancarias"),
    TIPOS_CONTATOS: "".concat(PrefixoAdmin, "/tipos-contatos"),
    TIPOS_SAIDAS: "".concat(PrefixoAdmin, "/tipos-saidas"),
    TIPOS_TRANSFERENCIAS: "".concat(PrefixoAdmin, "/tipos-transferencias"),
    TIPOS_NATUREZAS_CRIMES: "".concat(PrefixoAdmin, "/tipos-naturezas-crimes"),
    CATEGORIAS_CONTAS_BANCARIAS: "".concat(PrefixoAdmin, "/categorias-contas-bancarias"),
    TIPOS_IMOVEIS: "".concat(PrefixoAdmin, "/tipos-imoveis"),
    TIPOS_SEXOS: "".concat(PrefixoAdmin, "/tipos-sexos"),
    TIPOS_COMORBIDADES: "".concat(PrefixoAdmin, "/tipos-comorbidades"),
    TIPOS_DEPENDENCIAS: "".concat(PrefixoAdmin, "/tipos-dependencias"),
    TIPOS_FORMACOES: "".concat(PrefixoAdmin, "/tipos-formacoes"),
    TIPOS_REGIMES: "".concat(PrefixoAdmin, "/tipos-regimes"),
    TIPOS_DOCUMENTOS: "".concat(PrefixoAdmin, "/tipos-documentos"),
    REEDUCANDOS: "".concat(PrefixoAdmin, "/recrutamentos"),
    PERFIS_LABORAIS: "".concat(PrefixoAdmin, "/perfis-laborais"),
    JORNADAS_TRABALHO: "".concat(PrefixoAdmin, "/jornadas-trabalho"),
    TIPOS_STATUS_VAGAS: "".concat(PrefixoAdmin, "/tipos-status-vagas"),
    TIPOS_VINCULOS_TRABALHO: "".concat(PrefixoAdmin, "/tipos-vinculos-trabalho"),
    OFERTAS_VAGAS_TRABALHO: "".concat(PrefixoAdmin, "/vagas-trabalho"),
    OFERTAS_VAGAS_TRABALHO_VAGAS: "".concat(PrefixoAdmin, "/vagas-trabalho/vagas"),
    SELECAO_PROFISSIONAIS: "".concat(PrefixoAdmin, "/selecao-profissionais"),
    SELECAO_PROFISSIONAIS_VAGAS: "".concat(PrefixoAdmin, "/selecao-profissionais/vagas"),
    ATENDIMENTOS: "".concat(PrefixoAdmin, "/atendimentos"),
    CONTRATOS_TRABALHO: "".concat(PrefixoAdmin, "/contratos-trabalho"),
    ATENDIMENTO_VISUALIZAR_VAGA: "".concat(PrefixoAdmin, "/atendimentos/vaga"),
    TIPOS_ATENDIMENTOS: "".concat(PrefixoAdmin, "/tipos-atendimentos"),
    MODALIDADES_ATENDIMENTOS: "".concat(PrefixoAdmin, "/modalidades-atendimentos"),
    UNIDADES_PENITENCIARIAS: "".concat(PrefixoAdmin, "/unidades-penitenciarias"),
    ATENDIMENTOS_INSERCAO_LABORAL: "".concat(PrefixoAdmin, "/atendimentos-contagem"),
    ENCAMINHAMENTOS_ESCRITORIO_SOCIAL: "".concat(PrefixoAdmin, "/encaminhamentos-escritorio-social"),
    ENCAMINHAMENTOS_ESCRITORIO_SOCIAL_REEDUCANDO: "".concat(PrefixoAdmin, "/encaminhamentos-escritorio-social/reeducando"),
    ATENDIMENTOS_IDENTIFICACAO_CIVIL: "".concat(PrefixoAdmin, "/atendimentos-identificacao-civil"),
    ATENDIMENTOS_SEEU: "".concat(PrefixoAdmin, "/atendimentos-seeu"),
    ATENDIMENTOS_REINTEGRACAO: "".concat(PrefixoAdmin, "/atendimentos-reintegracao"),
    ATENDIMENTOS_ACOLHIMENTO: "".concat(PrefixoAdmin, "/atendimentos-acolhimento"),
    PARAMETROS_FOLHA: "".concat(PrefixoAdmin, "/parametros-folha"),
    PARAMETROS_INSTITUICOES: "".concat(PrefixoAdmin, "/parametros-instituicoes"),
    PARAMETROS_FOLHAS: "".concat(PrefixoAdmin, "/parametros-folhas"),
    RUBRICAS_FOLHAS: "".concat(PrefixoAdmin, "/rubricas-folhas"),
    LANCAMENTOS_FOLHAS: "".concat(PrefixoAdmin, "/lancamentos-folhas"),
    FOLHAS_MENSAIS: "".concat(PrefixoAdmin, "/folhas-mensais"),
    FOLHAS_COMPLEMENTARES: "".concat(PrefixoAdmin, "/folhas-complementares"),
    VINCULOS: "".concat(PrefixoAdmin, "/vinculos"),
    RESUMO_POR_COLABORADORES: "".concat(PrefixoAdmin, "/resumo-por-colaboradores"),
    // GESTÃO DE FREQUÊNCIA
    GF_VALIDACAO_DIARIA: "".concat(PrefixoAdmin, "/gestao-frequencia/validacao-diaria"),
    GF_TRATAMENTO_JUSTIFICATIVAS: "".concat(PrefixoAdmin, "/gestao-frequencia/tratamento-justificativas"),
    GF_CONTROLE_JUSTIFICATIVAS: "".concat(PrefixoAdmin, "/gestao-frequencia/controle-justificativas"),
    GF_FECHAMENTO_MENSAL: "".concat(PrefixoAdmin, "/gestao-frequencia/fechamento-mensal"),
    GF_PAINEL_ANALISE_FUNAC: "".concat(PrefixoAdmin, "/gestao-frequencia/painel-analise-funac"),
    GF_FILA_ANALISE_FUNAC: "".concat(PrefixoAdmin, "/gestao-frequencia/fila-analise-funac"),
    GF_RELATORIO_FREQUENCIA: "".concat(PrefixoAdmin, "/gestao-frequencia/relatorio-frequencia"),
    //painel
    HOME_PAINEL: "".concat(PrefixoAdmin),
};
export var PAGINAS = {
    // site
    HOME_SITE: "Home Site",
    //painel
    HOME_PAINEL: "In\u00EDcio",
    SEM_PERMISSAO: "Sem Permiss\u00E3o",
    SYSTEM_CHECK: "System Check",
    USUARIOS: "Usu\u00E1rios",
    PERFIS: "Perfis",
    DEPARTAMENTOS: "Departamentos",
    ORGAOS_EMPRESAS: "Org\u00E3os / Empresas",
    ACOES: "A\u00E7\u00F5es",
    FUNCIONALIDADES: "Funcionalidades",
    TIPOS_SERVIDORES: "Tipos de Servidores",
    CATEGORIAS_CNH: "Categorias de CNH",
    CIDADES: "Cidades",
    ESTADOS: "Estados",
    ESTADOS_CIVIS: "Estados Civis",
    GRAUS_ESCOLARIDADE: "Graus de Escolaridade",
    IDENTIDADES_GENERO: "Identidades de G\u00EAnero",
    NIVEIS_ESCOLARIDADE: "N\u00EDveis de Escolaridade",
    ORGAOS_EMISSORES_RG: "\u00D3rg\u00E3os Emissores de RG",
    ORIENTACOES_SEXUAIS: "Orienta\u00E7\u00F5es Sexuais",
    TIPOS_LOGRADOUROS: "Tipos de Logradouros",
    TIPOS_RACAS_CORES: "Tipos de Ra\u00E7as / Cores",
    //CONTRATOS E CONVENIOS
    CC_INSTITUICOES: "Institui\u00E7\u00F5es",
    CC_INSTITUICOES_DADOS: "Institui\u00E7\u00F5es - Dados",
    CC_INSTITUICOES_DOCUMENTOS: "Institui\u00E7\u00F5es - Documentos",
    CC_INSTITUICOES_TERMOS: "Institui\u00E7\u00F5es - Termos / Contratos",
    CC_TIPOS_TERMOS_DOCUMENTOS: "Tipos de Termos / Documentos",
    CC_TIPOS_EMPRESAS: "Tipos de Empresas",
    CC_TIPOS_CONTRATOS: "Tipos de Contratos",
    AGENCIAS_BANCARIAS: "Ag\u00EAncias Banc\u00E1rias",
    TIPOS_CONTAS_BANCARIAS: "Tipos de Contas Banc\u00E1rias",
    NOTIFICACOES: "Notifica\u00E7\u00F5es",
    TIPOS_CONTATOS: 'Tipos de Contatos',
    TIPOS_SAIDAS: 'Tipos de Saídas',
    TIPOS_TRANSFERENCIAS: 'Tipos de Transferências',
    TIPOS_NATUREZAS_CRIMES: 'Tipos de Naturezas de Crimes',
    CATEGORIAS_CONTAS_BANCARIAS: 'Categorias de Contas Bancárias',
    TIPOS_IMOVEIS: 'Tipos de Imóveis',
    TIPOS_SEXOS: 'Tipos de Sexos',
    TIPOS_COMORBIDADES: 'Tipos de Comorbidades',
    TIPOS_DEPENDENCIAS: 'Tipos de Dependências',
    TIPOS_FORMACOES: 'Tipos de Formações',
    TIPOS_DOCUMENTOS: "Tipos de Documentos",
    //REEDUCANDOS
    REEDUCANDOS: 'Recrutamentos',
    REEDUCANDOS_DADOS_PESSOAIS_1: 'Recrutamentos Dados Pessoais 1',
    REEDUCANDOS_DADOS_PESSOAIS_2: 'Recrutamentos Dados Pessoais 2',
    REEDUCANDOS_DADOS_PESSOAIS_3: 'Recrutamentos Dados Pessoais 3',
    REEDUCANDOS_FORMACOES: 'Recrutamentos Formações',
    REEDUCANDOS_EXPERIENCIAS_PROFISSIONAIS: 'Recrutamentos Experiências Profissionais',
    REEDUCANDOS_ENDEREÇOS: 'Recrutamentos Endereços',
    REEDUCANDOS_CONTATOS: 'Recrutamentos Contatos',
    REEDUCANDOS_DOCUMENTOS_ANEXOS: 'Recrutamentos Documentos Anexos',
    REEDUCANDOS_DEPENDENCIAS: 'Recrutamentos Dependências',
    REEDUCANDOS_COMORBIDADES: 'Recrutamentos Comorbidades',
    REEDUCANDOS_DEPENDENCIAS_COMORBIDADES: 'Recrutamentos Dependencias e Comorbidades',
    REEDUCANDOS_OBSERVAÇÕES_ADM: 'Recrutamentos Observações ADM',
    REEDUCANDOS_OCORRENCIAS: 'Recrutamentos Informações Legais',
    REEDUCANDOS_OUTRAS_INFORMACOES: 'Recrutamentos Outras Informações',
    REEDUCANDOS_SELECAO: 'Colaboradores Seleção',
    REEDUCANDOS_BUSCA: 'Colaboradores Busca',
    TIPOS_REGIMES: 'Tipos de Regimes',
    //VAGAS
    PERFIS_LABORAIS: "Perfis Laborais",
    JORNADAS_TRABALHO: "Jornadas de Trabalho",
    TIPOS_STATUS_VAGAS: "Tipos de Status de Vagas",
    TIPOS_VINCULOS_TRABALHO: "Tipos de V\u00EDnculos de Trabalho",
    OFERTAS_VAGAS_TRABALHO: "Ofertas de Vagas de Trabalho",
    OFERTAS_VAGAS_TRABALHO_VAGAS: "Vagas de Trabalho",
    SELECAO_PROFISSIONAIS: "Sele\u00E7\u00E3o de Profissionais",
    SELECAO_PROFISSIONAIS_VAGAS: "Sele\u00E7\u00E3o - Vagas de Trabalho",
    ATENDIMENTOS: "Atendimentos",
    CONTRATOS_TRABALHO: "Contratos de Trabalho",
    ATENDIMENTO_VISUALIZAR_VAGA: "Atendimento - Visualizar Vaga",
    TIPOS_ATENDIMENTOS: "Tipos de Atendimentos",
    MODALIDADES_ATENDIMENTOS: "Modalidades de Atendimentos",
    UNIDADES_PENITENCIARIAS: "Unidades Penitenci\u00E1rias",
    ENCAMINHAMENTOS_ESCRITORIO_SOCIAL: "Encaminhamentos - Escrit\u00F3rio Social",
    ENCAMINHAMENTOS_ESCRITORIO_SOCIAL_REEDUCANDO: "Escrit\u00F3rio Social - Reeducando",
    ATENDIMENTOS_IDENTIFICACAO_CIVIL: "Atendimentos",
    ATENDIMENTOS_INSERCAO_LABORAL: "Atendimentos - Inser\u00E7\u00E3o Laboral",
    ATENDIMENTOS_SEEU: "Atendimentos - SEEU",
    ATENDIMENTOS_REINTEGRACAO: "Atendimentos - Reintegra\u00E7\u00E3o",
    ATENDIMENTOS_ACOLHIMENTO: "Atendimentos - Acolhimento",
    ATENDIMENTOS_ADMIN: "ATENDIMENTOS_ADMIN",
    ATENDIMENTOS_REGIME_FECHADO: "ATENDIMENTOS_REGIME_FECHADO",
    ATENDIMENTOS_REGIME_SEMIABERTO: "ATENDIMENTOS_REGIME_SEMIABERTO",
    ATENDIMENTOS_REGIME_FECHADO_SEMIABERTO: "ATENDIMENTOS_REGIME_FECHADO_SEMIABERTO",
    //FINANCEIRO
    PARAMETROS_FOLHAS: "Par\u00E2metros das Folhas",
    PARAMETROS_INSTITUICOES: "Par\u00E2metros das Institui\u00E7\u00F5es",
    RUBRICAS_FOLHAS: "Rubricas das Folhas",
    LANCAMENTOS_FOLHAS: "Lan\u00E7amentos das Folhas",
    FOLHAS_MENSAIS: "Folhas Mensais",
    FOLHAS_COMPLEMENTARES: "Folhas Complementares",
    VINCULOS: "Gest\u00E3o de V\u00EDnculos",
    RESUMOS_COLABORADORES: "Resumos Colaboradores",
    FOLHA_ADMIN: "FOLHA_ADMIN",
    // GESTÃO DE FREQUÊNCIA
    GF_VALIDACAO_DIARIA: "Valida\u00E7\u00E3o Di\u00E1ria",
    GF_TRATAMENTO_JUSTIFICATIVAS: "Tratamento de Justificativas",
    GF_CONTROLE_JUSTIFICATIVAS: "Controle de Justificativas",
    GF_FECHAMENTO_MENSAL: "Fechamento Mensal",
    GF_PAINEL_ANALISE_FUNAC: "Painel de An\u00E1lise (FUNAC)",
    GF_FILA_ANALISE_FUNAC: "Fila de An\u00E1lise \u2014 Folhas Recebidas",
    GF_RELATORIO_FREQUENCIA: "Relat\u00F3rio de Frequ\u00EAncia",
    GF_PRIMEIRA_PAGINA: "Gest\u00E3o de Frequ\u00EAncia",
};
// Chaves de funcionalidade (campo `chave` de p_funcionalidades) usadas nas checagens de permissão.
// Cobre apenas as chaves de PAGINAS que efetivamente participam de alguma checagem de permissão hoje.
export var FUNCIONALIDADES = {
    USUARIOS: "SEGURANCA:USUARIOS",
    PERFIS: "SEGURANCA:PERFIS",
    DEPARTAMENTOS: "SEGURANCA:DEPARTAMENTOS",
    ORGAOS_EMPRESAS: "SEGURANCA:ORGAOS_EMPRESAS",
    ACOES: "SEGURANCA:ACOES",
    FUNCIONALIDADES: "SEGURANCA:FUNCIONALIDADES",
    TIPOS_SERVIDORES: "SEGURANCA:TIPOS_SERVIDORES",
    CATEGORIAS_CNH: "TABELAS_BASICAS:CATEGORIAS_CNH",
    CIDADES: "TABELAS_BASICAS:CIDADES",
    ESTADOS: "TABELAS_BASICAS:ESTADOS",
    ESTADOS_CIVIS: "TABELAS_BASICAS:ESTADOS_CIVIS",
    GRAUS_ESCOLARIDADE: "TABELAS_BASICAS:GRAUS_ESCOLARIDADE",
    IDENTIDADES_GENERO: "TABELAS_BASICAS:IDENTIDADES_GENERO",
    NIVEIS_ESCOLARIDADE: "TABELAS_BASICAS:NIVEIS_ESCOLARIDADE",
    ORGAOS_EMISSORES_RG: "TABELAS_BASICAS:ORGAOS_EMISSORES_RG",
    ORIENTACOES_SEXUAIS: "TABELAS_BASICAS:ORIENTACOES_SEXUAIS",
    TIPOS_LOGRADOUROS: "TABELAS_BASICAS:TIPOS_LOGRADOUROS",
    TIPOS_RACAS_CORES: "TABELAS_BASICAS:TIPOS_RACAS_CORES",
    CC_INSTITUICOES: "CONTRATOS_CONVENIOS:CC_INSTITUICOES",
    CC_INSTITUICOES_DADOS: "CONTRATOS_CONVENIOS:CC_INSTITUICOES_DADOS",
    CC_INSTITUICOES_DOCUMENTOS: "CONTRATOS_CONVENIOS:CC_INSTITUICOES_DOCUMENTOS",
    CC_INSTITUICOES_TERMOS: "CONTRATOS_CONVENIOS:CC_INSTITUICOES_TERMOS",
    CC_TIPOS_TERMOS_DOCUMENTOS: "CONTRATOS_CONVENIOS:CC_TIPOS_TERMOS_DOCUMENTOS",
    CC_TIPOS_EMPRESAS: "CONTRATOS_CONVENIOS:CC_TIPOS_EMPRESAS",
    CC_TIPOS_CONTRATOS: "CONTRATOS_CONVENIOS:CC_TIPOS_CONTRATOS",
    AGENCIAS_BANCARIAS: "CONTRATOS_CONVENIOS:AGENCIAS_BANCARIAS",
    TIPOS_CONTAS_BANCARIAS: "CONTRATOS_CONVENIOS:TIPOS_CONTAS_BANCARIAS",
    REEDUCANDOS: "RECRUTAMENTOS:COLABORADORES",
    REEDUCANDOS_BUSCA: "RECRUTAMENTOS:COLABORADORES",
    REEDUCANDOS_DADOS_PESSOAIS_1: "RECRUTAMENTOS:COLABORADORES_DADOS_PESSOAIS",
    // TODO: chave null no dump do backend para as abas 2 e 3; usando a mesma chave da aba 1 até definição da chave real.
    REEDUCANDOS_DADOS_PESSOAIS_2: "RECRUTAMENTOS:COLABORADORES_DADOS_PESSOAIS",
    REEDUCANDOS_DADOS_PESSOAIS_3: "RECRUTAMENTOS:COLABORADORES_DADOS_PESSOAIS",
    REEDUCANDOS_FORMACOES: "RECRUTAMENTOS:FORMACOES",
    REEDUCANDOS_EXPERIENCIAS_PROFISSIONAIS: "RECRUTAMENTOS:EXPERIENCIAS_PROFISSIONAIS",
    REEDUCANDOS_ENDEREÇOS: "RECRUTAMENTOS:ENDERECOS",
    REEDUCANDOS_CONTATOS: "RECRUTAMENTOS:CONTATOS",
    REEDUCANDOS_OBSERVAÇÕES_ADM: "RECRUTAMENTOS:OBSERVACOES_ADM",
    REEDUCANDOS_DOCUMENTOS_ANEXOS: "RECRUTAMENTOS:DOCUMENTOS_ANEXOS",
    REEDUCANDOS_COMORBIDADES: "RECRUTAMENTOS:COMORBIDADES",
    REEDUCANDOS_DEPENDENCIAS_COMORBIDADES: "RECRUTAMENTOS:DEPENDENCIAS_COMORBIDADES",
    REEDUCANDOS_OCORRENCIAS: "RECRUTAMENTOS:OCORRENCIAS",
    REEDUCANDOS_OUTRAS_INFORMACOES: "RECRUTAMENTOS:OUTRAS_INFORMACOES",
    REEDUCANDOS_SELECAO: "RECRUTAMENTOS:SELECAO",
    TIPOS_REGIMES: "RECRUTAMENTOS:TIPOS_REGIMES",
    TIPOS_CONTATOS: "RECRUTAMENTOS:TIPOS_CONTATOS",
    TIPOS_NATUREZAS_CRIMES: "RECRUTAMENTOS:TIPOS_NATUREZAS_CRIMES",
    CATEGORIAS_CONTAS_BANCARIAS: "RECRUTAMENTOS:CATEGORIAS_CONTAS_BANCARIAS",
    TIPOS_IMOVEIS: "RECRUTAMENTOS:TIPOS_IMOVEIS",
    TIPOS_FORMACOES: "RECRUTAMENTOS:TIPOS_FORMACOES",
    TIPOS_SEXOS: "RECRUTAMENTOS:TIPOS_SEXOS",
    TIPOS_COMORBIDADES: "RECRUTAMENTOS:TIPOS_COMORBIDADES",
    TIPOS_DEPENDENCIAS: "RECRUTAMENTOS:TIPOS_DEPENDENCIAS",
    TIPOS_DOCUMENTOS: "RECRUTAMENTOS:TIPOS_DOCUMENTOS",
    PERFIS_LABORAIS: "VAGAS:PERFIS_LABORAIS",
    JORNADAS_TRABALHO: "VAGAS:JORNADAS_TRABALHO",
    TIPOS_STATUS_VAGAS: "VAGAS:TIPOS_STATUS_VAGAS",
    TIPOS_VINCULOS_TRABALHO: "VAGAS:TIPOS_VINCULOS_TRABALHO",
    OFERTAS_VAGAS_TRABALHO: "VAGAS:OFERTAS_VAGAS_TRABALHO",
    OFERTAS_VAGAS_TRABALHO_VAGAS: "VAGAS:OFERTAS_VAGAS_TRABALHO_VAGAS",
    SELECAO_PROFISSIONAIS: "VAGAS:SELECAO_PROFISSIONAIS",
    SELECAO_PROFISSIONAIS_VAGAS: "VAGAS:SELECAO_PROFISSIONAIS_VAGAS",
    ATENDIMENTOS: "VAGAS:ATENDIMENTOS",
    ATENDIMENTO_VISUALIZAR_VAGA: "VAGAS:VISUALIZAR_VAGA",
    CONTRATOS_TRABALHO: "VAGAS:CONTRATOS_TRABALHO",
    TIPOS_ATENDIMENTOS: "VAGAS:TIPOS_ATENDIMENTOS",
    MODALIDADES_ATENDIMENTOS: "VAGAS:MODALIDADES_ATENDIMENTOS",
    UNIDADES_PENITENCIARIAS: "VAGAS:UNIDADES_PENITENCIARIAS",
    ENCAMINHAMENTOS_ESCRITORIO_SOCIAL: "VAGAS:ATENDIMENTOS_ESCRITORIO_SOCIAL",
    ENCAMINHAMENTOS_ESCRITORIO_SOCIAL_REEDUCANDO: "VAGAS:ATENDIMENTOS_ESCRITORIO_SOCIAL_REEDUCANDO",
    // Corrigido: PAGINAS.ATENDIMENTOS_IDENTIFICACAO_CIVIL tem o mesmo nome de PAGINAS.ATENDIMENTOS
    // (colisão pré-existente); a chave real e distinta é VAGAS:ATENDIMENTOS_IDENTIFICACAO_CIVIL.
    ATENDIMENTOS_IDENTIFICACAO_CIVIL: "VAGAS:ATENDIMENTOS_IDENTIFICACAO_CIVIL",
    ATENDIMENTOS_INSERCAO_LABORAL: "VAGAS:ATENDIMENTOS_INSERCAO_LABORAL",
    ATENDIMENTOS_SEEU: "VAGAS:ATENDIMENTOS_SEEU",
    ATENDIMENTOS_REINTEGRACAO: "VAGAS:ATENDIMENTOS_REINTEGRACAO",
    ATENDIMENTOS_ACOLHIMENTO: "VAGAS:ATENDIMENTOS_ACOLHIMENTO",
    ATENDIMENTOS_ADMIN: "VAGAS:ATENDIMENTOS_ADMIN",
    ATENDIMENTOS_REGIME_FECHADO: "VAGAS:ATENDIMENTOS_REGIME_FECHADO",
    ATENDIMENTOS_REGIME_SEMIABERTO: "VAGAS:ATENDIMENTOS_REGIME_SEMIABERTO",
    TIPOS_SAIDAS: "VAGAS:TIPOS_SAIDAS",
    TIPOS_TRANSFERENCIAS: "VAGAS:TIPOS_TRANSFERENCIAS",
    PARAMETROS_FOLHAS: "FINANCEIRO:PARAMETROS_FOLHAS",
    PARAMETROS_INSTITUICOES: "FINANCEIRO:PARAMETROS_INSTITUICOES",
    RUBRICAS_FOLHAS: "FINANCEIRO:RUBRICAS_FOLHAS",
    LANCAMENTOS_FOLHAS: "FINANCEIRO:LANCAMENTOS_FOLHAS",
    FOLHAS_MENSAIS: "FINANCEIRO:FOLHAS_MENSAIS",
    FOLHAS_COMPLEMENTARES: "FINANCEIRO:FOLHAS_COMPLEMENTARES",
    VINCULOS: "FINANCEIRO:GESTAO_VINCULO",
    FOLHA_ADMIN: "FINANCEIRO:FOLHA_ADMIN",
    GF_VALIDACAO_DIARIA: "GESTAO_FREQUENCIA:VALIDACAO_DIARIA",
    GF_TRATAMENTO_JUSTIFICATIVAS: "GESTAO_FREQUENCIA:TRATAMENTO_JUSTIFICATIVAS",
    // TODO: chave temporária (usando a de TRATAMENTO_JUSTIFICATIVAS) até o backend definir a chave real.
    GF_CONTROLE_JUSTIFICATIVAS: "GESTAO_FREQUENCIA:TRATAMENTO_JUSTIFICATIVAS",
    GF_FECHAMENTO_MENSAL: "GESTAO_FREQUENCIA:FECHAMENTO_MENSAL",
    GF_PAINEL_ANALISE_FUNAC: "GESTAO_FREQUENCIA:PAINEL_ANALISE",
    // TODO: chave temporária (usando a de PAINEL_ANALISE) até o backend definir a chave real.
    GF_RELATORIO_FREQUENCIA: "GESTAO_FREQUENCIA:PAINEL_ANALISE",
};
var RoutesConfig = [
    {
        path: '*',
        element: NotFoundPage,
    },
    {
        path: ROUTES.SYSTEM_CHECK,
        element: SystemCheck,
    },
    {
        path: ROUTES.LOGOUT,
        element: Logout,
    },
    {
        path: ROUTES.HOME_SITE,
        element: Home,
    },
    {
        path: ROUTES.HOME_PAINEL,
        element: HomePainel,
    },
    {
        path: ROUTES.SEM_PERMISSAO,
        element: SemPermissao,
    },
    {
        path: ROUTES.USUARIOS,
        element: Usuarios,
    },
    {
        path: ROUTES.USUARIOS + '/:id?/:modo',
        element: UsuariosAlterar,
    },
    {
        path: ROUTES.PERFIS,
        element: Perfis,
    },
    {
        path: ROUTES.PERFIS + '/:id?/:modo',
        element: PerfisAlterar,
    },
    {
        path: ROUTES.DEPARTAMENTOS,
        element: Departamentos,
    },
    {
        path: ROUTES.DEPARTAMENTOS + '/:id?/:modo',
        element: DepartamentosAlterar,
    },
    {
        path: ROUTES.ORGAOS_EMPRESAS,
        element: OrgaosEmpresas,
    },
    {
        path: ROUTES.ORGAOS_EMPRESAS + '/:id?/:modo',
        element: OrgaosEmpresasAlterar,
    },
    {
        path: ROUTES.ACOES,
        element: PerfilAcoes,
    },
    {
        path: ROUTES.ACOES + '/:id?/:modo',
        element: PerfilAcoesAlterar,
    },
    {
        path: ROUTES.FUNCIONALIDADES,
        element: Funcionalidades,
    },
    {
        path: ROUTES.FUNCIONALIDADES + '/:id?/:modo',
        element: FuncionalidadesAlterar,
    },
    {
        path: ROUTES.TIPOS_SERVIDORES,
        element: TiposServidor,
    },
    {
        path: ROUTES.TIPOS_SERVIDORES + '/:id?/:modo',
        element: TiposServidorAlterar,
    },
    {
        path: ROUTES.CATEGORIAS_CNH,
        element: CategoriasCNH,
    },
    {
        path: ROUTES.CATEGORIAS_CNH + '/:id?/:modo',
        element: CategoriasCNHAlterar,
    },
    {
        path: ROUTES.CIDADES,
        element: CidadesListar,
    },
    {
        path: ROUTES.CIDADES + '/:id?/:modo',
        element: CidadesAlterar,
    },
    {
        path: ROUTES.ESTADOS,
        element: Estados,
    },
    {
        path: ROUTES.ESTADOS + '/:id?/:modo',
        element: EstadosAlterar,
    },
    {
        path: ROUTES.GRAUS_ESCOLARIDADE,
        element: GrausEscolaridade,
    },
    {
        path: ROUTES.GRAUS_ESCOLARIDADE + '/:id?/:modo',
        element: GrausEscolaridadeAlterar,
    },
    {
        path: ROUTES.NIVEIS_ESCOLARIDADE,
        element: NiveisEscolaridade,
    },
    {
        path: ROUTES.NIVEIS_ESCOLARIDADE + '/:id?/:modo',
        element: NiveisEscolaridadeAlterar,
    },
    {
        path: ROUTES.ORGAOS_EMISSORES_RG,
        element: OrgaosEmissoresRG,
    },
    {
        path: ROUTES.ORGAOS_EMISSORES_RG + '/:id?/:modo',
        element: OrgaosEmissoresRGAlterar,
    },
    {
        path: ROUTES.ESTADOS_CIVIS,
        element: EstadosCivis,
    },
    {
        path: ROUTES.ESTADOS_CIVIS + '/:id?/:modo',
        element: EstadosCivisAlterar,
    },
    {
        path: ROUTES.TIPOS_LOGRADOUROS,
        element: TiposLogradouros,
    },
    {
        path: ROUTES.TIPOS_LOGRADOUROS + '/:id?/:modo',
        element: TiposLogradourosAlterar,
    },
    {
        path: ROUTES.ORIENTACOES_SEXUAIS,
        element: OrientacoesSexuais,
    },
    {
        path: ROUTES.ORIENTACOES_SEXUAIS + '/:id?/:modo',
        element: OrientacoesSexuaisAlterar,
    },
    {
        path: ROUTES.IDENTIDADES_GENERO,
        element: IdenditadesGenero,
    },
    {
        path: ROUTES.IDENTIDADES_GENERO + '/:id?/:modo',
        element: IdenditadesGeneroAlterar,
    },
    {
        path: ROUTES.TIPOS_RACAS_CORES,
        element: TiposRacasCores,
    },
    {
        path: ROUTES.TIPOS_RACAS_CORES + '/:id?/:modo',
        element: TiposRacasCoresAlterar,
    },
    {
        path: ROUTES.CC_INSTITUICOES,
        element: Instituicoes,
    },
    {
        path: ROUTES.CC_INSTITUICOES + '/:modo',
        element: InstituicoesAlterar,
    },
    {
        path: ROUTES.CC_INSTITUICOES + '/:id/:modo',
        element: InstituicoesAlterar,
    },
    {
        path: ROUTES.CC_TIPOS_CONTRATOS,
        element: TiposContratos,
    },
    {
        path: ROUTES.CC_TIPOS_CONTRATOS + '/:id?/:modo',
        element: TiposContratosAlterar,
    },
    {
        path: ROUTES.CC_TIPOS_TERMOS_DOCUMENTOS,
        element: TiposTermosDocumentos,
    },
    {
        path: ROUTES.CC_TIPOS_TERMOS_DOCUMENTOS + '/:id?/:modo',
        element: TiposTermosDocumentosAlterar,
    },
    {
        path: ROUTES.CC_TIPOS_EMPRESAS,
        element: TiposEmpresas,
    },
    {
        path: ROUTES.CC_TIPOS_EMPRESAS + '/:id?/:modo',
        element: TiposEmpresasAlterar,
    },
    {
        path: ROUTES.AGENCIAS_BANCARIAS,
        element: AgenciasBancarias,
    },
    {
        path: ROUTES.AGENCIAS_BANCARIAS + '/:id?/:modo',
        element: AgenciasBancariasAlterar,
    },
    {
        path: ROUTES.TIPOS_CONTAS_BANCARIAS,
        element: TiposContasBancarias,
    },
    {
        path: ROUTES.TIPOS_CONTAS_BANCARIAS + '/:id?/:modo',
        element: TiposContasBancariasAlterar,
    },
    {
        path: ROUTES.TIPOS_CONTATOS,
        element: TiposContatosListar,
    },
    {
        path: ROUTES.TIPOS_CONTATOS + '/:id?/:modo',
        element: TiposContatosAlterar,
    },
    {
        path: ROUTES.TIPOS_TRANSFERENCIAS,
        element: TiposTransferenciasListar,
    },
    {
        path: ROUTES.TIPOS_TRANSFERENCIAS + '/:id?/:modo',
        element: TiposTransferenciasAlterar,
    },
    {
        path: ROUTES.TIPOS_SAIDAS,
        element: TiposSaidasListar,
    },
    {
        path: ROUTES.TIPOS_SAIDAS + '/:id?/:modo',
        element: TiposSaidasAlterar,
    },
    {
        path: ROUTES.TIPOS_NATUREZAS_CRIMES,
        element: TiposNaturezasCrimesListar,
    },
    {
        path: ROUTES.TIPOS_NATUREZAS_CRIMES + '/:id?/:modo',
        element: TiposNaturezasCrimesAlterar,
    },
    {
        path: ROUTES.TIPOS_CONTATOS,
        element: TiposContatosListar,
    },
    {
        path: ROUTES.TIPOS_CONTATOS + '/:id?/:modo',
        element: TiposContatosAlterar,
    },
    {
        path: ROUTES.CATEGORIAS_CONTAS_BANCARIAS,
        element: CategoriasContasBancariasListar,
    },
    {
        path: ROUTES.CATEGORIAS_CONTAS_BANCARIAS + '/:id?/:modo',
        element: CategoriasContasBancariasAlterar,
    },
    {
        path: ROUTES.TIPOS_IMOVEIS,
        element: TiposImoveisListar,
    },
    {
        path: ROUTES.TIPOS_IMOVEIS + '/:id?/:modo',
        element: TiposImoveisAlterar,
    },
    {
        path: ROUTES.TIPOS_SEXOS,
        element: TiposSexosListar,
    },
    {
        path: ROUTES.TIPOS_SEXOS + '/:id?/:modo',
        element: TiposSexosAlterar,
    },
    {
        path: ROUTES.TIPOS_COMORBIDADES,
        element: TiposComorbidadesListar,
    },
    {
        path: ROUTES.TIPOS_COMORBIDADES + '/:id?/:modo',
        element: TiposComorbidadesAlterar,
    },
    {
        path: ROUTES.TIPOS_DEPENDENCIAS,
        element: TiposDependenciasListar,
    },
    {
        path: ROUTES.TIPOS_DEPENDENCIAS + '/:id?/:modo',
        element: TiposDependenciasAlterar,
    },
    {
        path: ROUTES.TIPOS_FORMACOES,
        element: TiposFormacoesListar,
    },
    {
        path: ROUTES.TIPOS_FORMACOES + '/:id?/:modo',
        element: TiposFormacoesAlterar,
    },
    {
        path: ROUTES.TIPOS_REGIMES,
        element: TiposRegimesListar,
    },
    {
        path: ROUTES.TIPOS_REGIMES + '/:id?/:modo',
        element: TiposRegimesAlterar,
    },
    {
        path: ROUTES.TIPOS_DOCUMENTOS,
        element: TiposDocumentosListar,
    },
    {
        path: ROUTES.TIPOS_DOCUMENTOS + '/:id?/:modo',
        element: TiposDocumentosEditar,
    },
    {
        path: ROUTES.REEDUCANDOS,
        element: ReeducandosListar,
    },
    {
        path: ROUTES.REEDUCANDOS + '/:id?/:modo',
        element: ReeducandosAlterar,
    },
    {
        path: ROUTES.PERFIS_LABORAIS,
        element: PerfisLaboraisListar,
    },
    {
        path: ROUTES.PERFIS_LABORAIS + '/:id?/:modo',
        element: PerfisLaboraisAlterar,
    },
    {
        path: ROUTES.JORNADAS_TRABALHO,
        element: JornadasTrabalhoListar,
    },
    {
        path: ROUTES.JORNADAS_TRABALHO + '/:id?/:modo',
        element: JornadasTrabalhoAlterar,
    },
    {
        path: ROUTES.TIPOS_STATUS_VAGAS,
        element: TiposStatusVagasListar,
    },
    {
        path: ROUTES.TIPOS_STATUS_VAGAS + '/:id?/:modo',
        element: TiposStatusVagasAlterar,
    },
    {
        path: ROUTES.TIPOS_VINCULOS_TRABALHO,
        element: TiposVinculosTrabalhosListar,
    },
    {
        path: ROUTES.TIPOS_VINCULOS_TRABALHO + '/:id?/:modo',
        element: TiposVinculosTrabalhosAlterar,
    },
    {
        path: ROUTES.OFERTAS_VAGAS_TRABALHO,
        element: OfertasVagasTrabalhosListar,
    },
    {
        path: ROUTES.OFERTAS_VAGAS_TRABALHO + '/:id?/:modo',
        element: OfertasVagasTrabalhosAlterar,
    },
    {
        path: ROUTES.OFERTAS_VAGAS_TRABALHO_VAGAS,
        element: OfertasVagasAlterarVagas,
    },
    {
        path: ROUTES.OFERTAS_VAGAS_TRABALHO_VAGAS + '/:id?/:modo',
        element: OfertasVagasAlterarVagas,
    },
    {
        path: ROUTES.SELECAO_PROFISSIONAIS,
        element: SelecaoProfissionaisListar,
    },
    {
        path: ROUTES.SELECAO_PROFISSIONAIS + '/:id?/:modo',
        element: SelecaoProfissionaisListar,
    },
    {
        path: ROUTES.SELECAO_PROFISSIONAIS_VAGAS,
        element: SelecaoVagas,
    },
    {
        path: ROUTES.SELECAO_PROFISSIONAIS_VAGAS + '/:id?/:modo',
        element: SelecaoVagas,
    },
    {
        path: ROUTES.ATENDIMENTOS,
        element: AtendimentosListar,
    },
    {
        path: ROUTES.ATENDIMENTOS + '/:id?/:modo',
        element: AtendimentosEditar,
    },
    {
        path: ROUTES.ATENDIMENTO_VISUALIZAR_VAGA + '/:id?/:modo',
        element: AtendimentosDetalheVaga,
    },
    {
        path: ROUTES.CONTRATOS_TRABALHO,
        element: ContratosTrabalhoListar,
    },
    {
        path: ROUTES.CONTRATOS_TRABALHO + '/:id?/:modo',
        element: ContratosTrabalhoEditar,
    },
    {
        path: ROUTES.TIPOS_ATENDIMENTOS,
        element: TiposAtendimentosListar,
    },
    {
        path: ROUTES.TIPOS_ATENDIMENTOS + '/:id?/:modo',
        element: TiposAtendimentosAlterar,
    },
    { path: ROUTES.MODALIDADES_ATENDIMENTOS, element: ModalidadesAtendimentosListar },
    {
        path: ROUTES.MODALIDADES_ATENDIMENTOS + '/:id?/:modo',
        element: ModalidadesAtendimentosAlterar,
    },
    {
        path: ROUTES.UNIDADES_PENITENCIARIAS,
        element: UnidadesPenitenciariasListar,
    },
    { path: ROUTES.UNIDADES_PENITENCIARIAS + '/:id?/:modo', element: UnidadesPenitenciariasAlterar },
    {
        path: ROUTES.ATENDIMENTOS_INSERCAO_LABORAL,
        element: AtendimentosInsercaoLaboralListar,
    },
    {
        path: ROUTES.ATENDIMENTOS_INSERCAO_LABORAL + '/:id?/:modo',
        element: AtendimentosInsercaoLaboralEditar,
    },
    {
        path: ROUTES.ENCAMINHAMENTOS_ESCRITORIO_SOCIAL,
        element: AtendimentosControleSocialListar,
    },
    {
        path: ROUTES.ENCAMINHAMENTOS_ESCRITORIO_SOCIAL + '/:id?/:modo',
        element: AtendimentosControleSocialEditar,
    },
    {
        path: ROUTES.ENCAMINHAMENTOS_ESCRITORIO_SOCIAL + '/reeducando/:modo',
        element: AtendimentosControleSocialReeducando,
    },
    {
        path: ROUTES.ATENDIMENTOS_IDENTIFICACAO_CIVIL,
        element: AtendimentosIdentificacaoCivilListar,
    },
    {
        path: ROUTES.ATENDIMENTOS_IDENTIFICACAO_CIVIL + '/:id?/:modo',
        element: AtendimentosIdentificacaoCivilEditar,
    },
    {
        path: ROUTES.ATENDIMENTOS_SEEU,
        element: AtendimentosSeeuListar,
    },
    {
        path: ROUTES.ATENDIMENTOS_SEEU + '/:id?/:modo',
        element: AtendimentosSeeuEditar,
    },
    {
        path: ROUTES.ATENDIMENTOS_REINTEGRACAO,
        element: AtendimentosReintegracaoListar,
    },
    {
        path: ROUTES.ATENDIMENTOS_REINTEGRACAO + '/:id?/:modo',
        element: AtendimentosReintegracaoEditar,
    },
    {
        path: ROUTES.ATENDIMENTOS_ACOLHIMENTO,
        element: AtendimentosAcolhimnetoListar,
    },
    {
        path: ROUTES.ATENDIMENTOS_ACOLHIMENTO + '/:id?/:modo',
        element: AtendimentosAcolhimnetoEditar,
    },
    {
        path: ROUTES.PARAMETROS_INSTITUICOES,
        element: ParametrosInstituicoesListar,
    },
    {
        path: ROUTES.PARAMETROS_INSTITUICOES + '/:id/contrato/:termoId/parametros/:modo',
        element: ParametrosInstituicoesConfigurar,
    },
    {
        path: ROUTES.PARAMETROS_INSTITUICOES + '/:id?/:modo',
        element: ParametrosInstituicoesEditar,
    },
    {
        path: ROUTES.PARAMETROS_FOLHAS,
        element: ParametrosParametrosFolhasListar,
    },
    {
        path: ROUTES.PARAMETROS_FOLHAS + '/:id?/:modo',
        element: ParametrosParametrosFolhasEditar,
    },
    {
        path: ROUTES.RUBRICAS_FOLHAS,
        element: RubricasFolhasEditar,
    },
    {
        path: ROUTES.LANCAMENTOS_FOLHAS,
        element: LancamentosFolhasListar,
    },
    {
        path: ROUTES.LANCAMENTOS_FOLHAS + '/:id?/:modo',
        element: LancamentosFolhasEditar,
    },
    {
        path: ROUTES.FOLHAS_MENSAIS,
        element: FolhasMensaisListar,
    },
    {
        path: ROUTES.VINCULOS,
        element: VinculosGestao,
    },
    {
        path: ROUTES.FOLHAS_COMPLEMENTARES,
        element: FolhasComplementaresListar,
    },
    {
        path: ROUTES.FOLHAS_COMPLEMENTARES + '/:id?/:modo',
        element: FolhasComplementaresListar,
    },
    {
        path: ROUTES.RESUMO_POR_COLABORADORES,
        element: LancamentosFolhasListar,
    },
    {
        path: ROUTES.RESUMO_POR_COLABORADORES + '/:id?/:modo',
        element: LancamentosFolhasEditar,
    },
    {
        path: ROUTES.GF_VALIDACAO_DIARIA,
        element: ValidacaoDiariaListar,
    },
    {
        path: ROUTES.GF_VALIDACAO_DIARIA + '/detalhes/:id',
        element: ValidacaoDiariaDetalhes,
    },
    {
        path: ROUTES.GF_TRATAMENTO_JUSTIFICATIVAS,
        element: TratamentoJustificativasListar,
    },
    {
        path: ROUTES.GF_CONTROLE_JUSTIFICATIVAS,
        element: ControleJustificativasListar,
    },
    {
        path: ROUTES.GF_CONTROLE_JUSTIFICATIVAS + '/:id?/:modo',
        element: ControleJustificativasEditar,
    },
    {
        path: ROUTES.GF_FECHAMENTO_MENSAL,
        element: FechamentoMensalListar,
    },
    {
        path: ROUTES.GF_PAINEL_ANALISE_FUNAC,
        element: PainelAnaliseFunacListar,
    },
    {
        path: ROUTES.GF_FILA_ANALISE_FUNAC,
        element: FilaAnaliseFunacListar,
    },
    {
        path: ROUTES.GF_RELATORIO_FREQUENCIA,
        element: RelatorioFrequencia,
    },
];
export default RoutesConfig;
